import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { CreateUserRequest, UpdateUserRequest, UserSummary } from "@opus-dt/shared-types";

const QK = ["users"] as const;

export function useUsers() {
  return useQuery<UserSummary[]>({
    queryKey: QK,
    queryFn: () => api.get<UserSummary[]>("/api/v1/users"),
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateUserRequest) => api.post<UserSummary>("/api/v1/users", data),
    meta: { skipErrorToast: true },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateUserRequest }) =>
      api.patch<UserSummary>(`/api/v1/users/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/api/v1/users/${id}`),
    meta: { skipErrorToast: true },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
